import * as React from "react";
import { useNavigate } from "react-router-dom";
import { GroupManagement } from "@/components/GroupManagement";
import { Button } from "@/components/primitives";
import { ArrowLeft } from "lucide-react";

export default function MyGroups() {
	const navigate = useNavigate();

	return (
		<div className="container mx-auto px-4 py-8 max-w-7xl">
			<div className="flex items-center justify-between mb-4">
				<div>
					<h1 className="text-2xl font-bold">My Groups</h1>
				</div>
				<div>
					<Button
						variant="ghost"
						onClick={() =>
							window.history.length > 1 ? navigate(-1) : navigate("/mentor")
						}
					>
						<ArrowLeft className="w-4 h-4 mr-2" />
						Back to Dashboard
					</Button>
				</div>
			</div>

			<GroupManagement />
		</div>
	);
}
